// Local development uses the backend's Development (test database) configuration.
// Override explicitly for another test host; production builds retain the existing URL.
export const apiUrl = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'development' ? 'https://localhost:7090' : 'https://fmhcnano.com/api');
